import React from "react";
import { Icon } from "../types";

export const LinearGradient: React.FC<Icon> = ({style}) => (
  <svg
    viewBox="0 0 1441 415"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g opacity="0.3">
      <path
        d="M196.378 225.831C122.16 202.756 35.2019 235.445 1 254.674V414.553H1440V36.2162C1368.18 49.4156 1307.16 45.9927 1295.62 114.923C1286.2 171.142 1285.79 211.23 1235.77 222.962C1185.48 234.757 1156.25 165.765 1105.8 114.923C1065.44 74.2492 997.47 127.176 972.389 144.124C927.926 173.618 826.85 109.265 783.047 58.6785C720.5 -13.5535 638.247 -20.16 576.125 58.6785C514.004 137.517 452.386 72.8804 375.004 114.923C297.622 156.965 289.151 254.674 196.378 225.831Z"
        fill="url(#paint0_linear_3735_17265)"
      />
      <path
        d="M1 254.997C35.2019 235.744 122.16 203.013 196.378 226.117C289.151 254.997 297.622 157.164 375.004 115.067C452.386 72.9711 514.004 137.69 576.125 58.751C638.246 -20.1884 720.5 -13.5734 783.047 58.751C826.85 109.402 927.926 173.838 972.389 144.306C997.47 127.337 1065.44 74.3417 1105.8 115.067C1156.25 165.974 1185.48 235.055 1235.77 223.245C1285.79 211.497 1286.2 171.359 1295.62 115.067C1307.16 46.049 1368.18 49.4763 1440 36.26"
        stroke="#F40009"
        strokeWidth="3.5"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3735_17265"
        x1="720.5"
        y1="2"
        x2="720.5"
        y2="414.553"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD8E0" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
